import React from 'react';
import Button from '../../../ui/button/button';

import { useIdentityManager } from '../../../../common/hooks/useIdentityManager';
// @ts-ignore
import logoImg from '../../assets/logo/sanne-logo-black.png';
import useTranslate from '../../../../common/hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import LogoSize from '../../../../common/services/config/brandingStore';
import EmailStore from '../../../../common/services/config/emailStore';
import Logo from '../../../ui/logo/logo';

import './agreementDecline.scss';

const AgreementDecline: React.FC<any> = (props) => {
  const identity = useIdentityManager();
  const { t } = useTranslate();
  const navigate = useNavigate();

  const close = () => {
    navigate('/agreements');
  };

  return (
    <div className='agreements-wrapper'>
      <div className='agreements-content'>
        <div className='agreements-header'>
          <div className='logo'>
            <Logo logoSource='/branding/logo.png' />
          </div>
        </div>
        <div className='agreements-title'>
          <span>{t('AGREEMENTS_DECLINED.TITLE')}</span>
        </div>
        <div className='consent-text info1'>
          <span>{t('AGREEMENTS_DECLINED.INFO_1')}</span>
          <br />
          <a className={'pointer login-page'} href={`mailto:${EmailStore.default_email}`}>
            {EmailStore.default_email}
          </a>
        </div>
        <div className='consent-text info2'>
          <span>{t('AGREEMENTS_DECLINED.INFO_2')}</span>
          <span className={'pointer login-page'} onClick={() => identity.signOut()}>
            {' '}
            {t('AGREEMENTS_DECLINED.LOGIN')}
          </span>
        </div>
        <div className='button-group'>
          <span className="hidden-desktop">{t('AGREEMENTS.APPROVE')}</span>
          <Button buttonStyle='button-wrapper button-wrapper-oval' handleClick={() => close()}>
            {t('AGREEMENTS_DECLINED.CLOSE')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgreementDecline;
